var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3438 9.5H11.375V4.25C11.375 3.78516 10.9648 3.375 10.5 3.375H5.25V1.40625C5.25 1.05078 4.94922 0.75 4.59375 0.75H3.28125C2.89844 0.75 2.625 1.05078 2.625 1.40625V3.375H0.65625C0.273438 3.375 0 3.67578 0 4.03125V5.34375C0 5.72656 0.273438 6 0.65625 6H2.625V11.25C2.625 11.7422 3.00781 12.125 3.5 12.125H8.75V14.0938C8.75 14.4766 9.02344 14.75 9.40625 14.75H10.7188C11.0742 14.75 11.375 14.4766 11.375 14.0938V12.125H13.3438C13.6992 12.125 14 11.8516 14 11.4688V10.1562C14 9.80078 13.6992 9.5 13.3438 9.5ZM2.625 5.125H0.875V4.25H2.625V5.125ZM8.75 11.25H3.5V1.625H4.375V10.375H8.75V11.25ZM8.75 9.5H5.25V6H8.75V9.5ZM10.5 13.875H9.625V5.125H5.25V4.25H10.5V13.875ZM13.125 11.25H11.375V10.375H13.125V11.25Z",
    fill: "#0085E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFit);
export default __webpack_public_path__ + "static/media/fit.c5caac23.svg";
export { ForwardRef as ReactComponent };